<template>
  <div class="page sizeA4">
    <div class="m-4">
      <!-- imagens do topo -->
      <div class="row">
        <div class="d-flex justify-content-between mb-2">
          <div class="col-md-6">
            <img
              style="width: 60%"
              src="@/assets/images/extrato/unicampoLogo.jpg"
            />
          </div>
          <div class="col-md-6">
            <div class="barraVerde"></div>
          </div>
        </div>
      </div>
      <div v-if="!cabecalho" class="d-flex justify-content-center">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
      </div>
      <div v-else>
        <!-- informações do cooperado -->
        <div class="row">
          <div class="col-md-12 mb-4">
            <h1 class="text-dark fw-bolder">
              Olá, {{ cabecalho.nm_cooperado }}!
            </h1>
            <h1 class="text-dark fw-bolder">
              Aqui está o seu
              <span class="text-success">demonstrativo de produção</span> de
            </h1>
            <h1 class="text-dark fw-bolder">
              {{
                $tools.mesesDoAno(
                  parseInt(cabecalho.mes_referencia.substr(0, 2))
                )
              }}
              de {{ cabecalho.ano_referencia }}.
            </h1>
          </div>
        </div>
        <!-- informações da folha -->
        <div class="row">
          <div class="d-flex flex-column mb-2">
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2"
                >PERÍODO DO PROJETO</label
              >
              <span class="fw-bold text-sencodary mx-4">
                {{
                  this.$tools.converteData(
                    cabecalho.dt_inicio_projeto.substr(0, 10)
                  )
                }}
                a
                {{
                  this.$tools.converteData(
                    cabecalho.dt_final_projeto.substr(0, 10)
                  )
                }}
              </span>
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2"
                >COOPERADO(A)</label
              >
              <span class="fw-bold text-sencodary mx-4"
                >{{ cabecalho.nm_cooperado }} [{{
                  cabecalho.cd_cooperado
                }}]</span
              >
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2">PROJETO</label>
              <span class="fw-bold text-sencodary mx-4"
                >{{ cabecalho.nm_projeto }} [{{ cabecalho.cd_projeto }}]</span
              >
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2">MATRÍCULA</label>
              <span class="fw-bold text-sencodary mx-4">{{
                cabecalho.nr_matricula
              }}</span>
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2"
                >DATA ADMISSÃO</label
              >
              <span class="fw-bold text-sencodary mx-4">{{
                $tools.converteData(cabecalho.dt_admissao.substr(0, 10))
              }}</span>
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2"
                >PERÍODO FOLHA</label
              >
              <span class="fw-bold text-sencodary mx-4">
                {{
                  this.$tools.converteData(
                    cabecalho.dt_periodo_inicial.substr(0, 10)
                  )
                }}
                a
                {{
                  this.$tools.converteData(
                    cabecalho.dt_periodo_final.substr(0, 10)
                  )
                }}
              </span>
            </div>
          </div>
        </div>
        <!-- resumo de valores do cooperado -->
        <div class="row justify-content-center">
          <div
            class="d-flex justify-content-center flex-column text-center my-2 p-3 w-50"
            style="background-color: #f8f9fa"
          >
            <h5 class="text-primary fw-bolder">Créditos</h5>
            <span class="text-primary fw-bolder font-size-24">{{
              $tools.converteReal(valoresFolha.vl_bruto)
            }}</span>
            <hr
              class="my-3 m-auto"
              style="
                width: 2em;
                height: 0.5em;
                color: #000;
                opacity: 1 !important;
              "
            />
            <h5 class="text-danger fw-bolder">Descontos</h5>
            <span class="text-danger fw-bolder font-size-24"
              >-{{ $tools.converteReal(valoresFolha.vl_descontoTotal) }}</span
            >
            <hr
              class="my-3 m-auto"
              style="
                width: 28em;
                height: 0.5em;
                color: #000;
                opacity: 1 !important;
              "
            />
            <h5 class="text-dark fw-bolder">
              Valor Líquido
              <span class="text-success font-size-24 fw-bolder">
                {{ $tools.converteReal(cabecalho.vl_liquido) }}
              </span>
            </h5>
            <p class="fw-bold text-decoration-underline">
              <strong>PREVISÃO DE PAGAMENTO</strong> em
              <strong style="font-size: 18px">{{
                $tools.converteData(cabecalho.dt_credito.substr(0, 10))
              }}</strong>
            </p>
            <P
              style="
                padding: 0;
                color: hsl(233deg 3% 51%);
                font-family: Verdana, Geneva, Tahoma, sans-serif;
                font-size: 8px;
                line-height: 20px;
                text-align: center;
              "
              >{{ cabecalho.sq_folha }}</P
            >
          </div>
        </div>
        <!-- total por tipo de item -->
        <div class="row my-5 justify-content-center" v-if="graficoItens">
          <div class="col-md-6">
            <h4 class="text-dark fw-bolder mb-4 text-center">
              TOTAIS POR TIPO DE ITEM
            </h4>
            <apexchart
              height="350"
              class="apex-color"
              type="pie"
              :series="graficoItens.series"
              :options="graficoItens.chartOptions"
            ></apexchart>
          </div>
        </div>

        <!-- RODAPÉ -->
        <div class="row quebraPagina">
          <div class="d-flex justify-content-between mt-5">
            <div class="col-md-6 align-self-end">
              <div class="barraVerde"></div>
            </div>
          </div>
        </div>

        <!-- imagens do topo -->
        <div class="row">
          <div class="d-flex justify-content-between mb-2">
            <div class="col-md-6">
              <img
                style="width: 60%"
                src="@/assets/images/extrato/unicampoLogo.jpg"
              />
            </div>
            <div class="col-md-6">
              <div class="barraVerde"></div>
            </div>
          </div>
        </div>

        <!-- detalhamento da folha de produção -->
        <div class="row">
          <div class="col-md-12">
            <h4 class="text-dark fw-bolder mb-4 text-center">
              DETALHAMENTO DA FOLHA DE PRODUÇÃO
            </h4>
            <div class="row">
              <b-table
                responsive="sm"
                class="tableFolhaProducao"
                :fields="camposFolhaProdutor"
                :items="tabelaFolhaProdutor"
                :per-page="perPage"
                :current-page="currentPage"
                foot-clone
                small
              >
                <template v-slot:cell(ds_item)="data">
                  {{ data.item.ds_item }}
                </template>
                <template v-slot:row-details="data">
                  <b-table
                    responsive="sm"
                    :fields="camposComposicao"
                    :items="montaDadosComposicao(data.item.sq_item)"
                    style="font-size: 11px"
                    small
                  >
                    <template #head(origem)="">
                      <i class="mdi mdi-subdirectory-arrow-right" /> Origem
                    </template>
                    <template v-slot:row-details="data">
                      <div class="bg-soft bg-warning">
                        <thead role="rowgroup">
                          <tr role="row">
                            <th role="columnheader">
                              <i class="mdi mdi-subdirectory-arrow-right" />
                              Observação
                            </th>
                          </tr>
                        </thead>
                        <tbody role="rowgroup">
                          <tr role="row" class="b-table-has-details">
                            <td role="cell">{{ data.item.ds_observacao }}</td>
                          </tr>
                        </tbody>
                      </div>
                    </template>
                    <template v-slot:cell(vl_lcto)="data">
                      <span v-if="data.item.tp_item === 'C'">
                        {{ data.item.vl_lcto }}%
                      </span>
                      <span v-else>
                        {{ $tools.converteReal(data.item.vl_lcto) }}
                      </span>
                    </template>
                  </b-table>
                </template>
                <template #foot()="">
                  <h6></h6>
                </template>
                <template #foot(qt_lcto)="">
                  <div class="text-end">
                    <span class="text-dark fw-bold">TOTAIS </span>
                  </div>
                </template>
                <template #foot(vl_lcto)="">
                  <span class="text-primary">
                    {{ $tools.converteReal(totalProventos) }}
                  </span>
                </template>
                <template #foot(tp_natureza)="">
                  <span class="text-danger">
                    {{ $tools.converteReal(totalDescontos) }}
                  </span>
                </template>
              </b-table>
              <div class="text-end">
                <label class="text-dark fw-bolder"
                  >VALOR LÍQUIDO
                  <span class="text-success font-size-20">
                    {{ $tools.converteReal(cabecalho.vl_liquido) }}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- DEPENDENTES DO IMPOSTO DE RENDA -->
        <div class="row mt-5" v-if="tabelaDependentes.length > 0">
          <div class="col-md-12">
            <h4 class="text-dark fw-bolder mb-4 text-center">
              DEPENDENTES DO IMPOSTO DE RENDA
            </h4>
            <div class="row">
              <b-table
                responsive="sm"
                class="tableDependentes"
                :fields="camposDependentes"
                :items="tabelaDependentes"
                striped
                small
              >
              </b-table>
            </div>
          </div>
        </div>

        <!-- RODAPÉ -->
        <div class="row quebraPagina">
          <div class="d-flex justify-content-between mt-5">
            <div class="col-md-6 align-self-end">
              <div class="barraVerde"></div>
            </div>
          </div>
        </div>
        <!-- imagens do topo -->
        <div class="row">
          <div class="d-flex justify-content-between mb-2">
            <div class="col-md-6">
              <img
                style="width: 60%"
                src="@/assets/images/extrato/unicampoLogo.jpg"
              />
            </div>
            <div class="col-md-6">
              <div class="barraVerde"></div>
            </div>
          </div>
        </div>

        <!-- gráficos -->
        <div class="row mt-5">
          <div class="col-md-6" v-if="graficoCreditos">
            <b-card class="heightCardHeader">
              <b-card-title>
                {{ graficoCreditos.nameChart }}
              </b-card-title>
              <apexchart
                class="apex-color"
                height="350"
                type="bar"
                :series="graficoCreditos.series"
                :options="graficoCreditos.chartOptions"
              ></apexchart>
            </b-card>
          </div>
          <div class="col-md-6" v-if="graficoImpostos">
            <b-card class="heightCardHeader">
              <b-card-title>
                {{ graficoImpostos.nameChart }}
              </b-card-title>
              <apexchart
                class="apex-color"
                height="350"
                type="bar"
                :series="graficoImpostos.series"
                :options="graficoImpostos.chartOptions"
              ></apexchart>
            </b-card>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-6" v-if="graficoTaxaRetencao">
            <b-card class="heightCardHeader">
              <b-card-title>
                {{ graficoTaxaRetencao.nameChart }}
              </b-card-title>
              <apexchart
                class="apex-color"
                height="350"
                type="bar"
                :series="graficoTaxaRetencao.series"
                :options="graficoTaxaRetencao.chartOptions"
              ></apexchart>
            </b-card>
          </div>
          <div class="col-md-6" v-if="graficoDebitos">
            <b-card class="heightCardHeader">
              <b-card-title>
                {{ graficoDebitos.nameChart }}
              </b-card-title>
              <apexchart
                class="apex-color"
                height="350"
                type="bar"
                :series="graficoDebitos.series"
                :options="graficoDebitos.chartOptions"
              ></apexchart>
            </b-card>
          </div>
        </div>
        <div class="row" v-if="graficoOutros">
          <div class="col-md-6">
            <b-card class="heightCardHeader">
              <b-card-title>
                {{ graficoOutros.nameChart }}
              </b-card-title>
              <apexchart
                class="apex-color"
                height="350"
                type="bar"
                :series="graficoOutros.series"
                :options="graficoOutros.chartOptions"
              ></apexchart>
            </b-card>
          </div>
        </div>

        <!-- calculos base -->
        <!-- <div class="row justify-content-center">
          <div class="text-center my-2 p-3 mt-5 w-75" style="background-color: #f8f9fa">
            <h5 class="text-dark fw-bolder mt-4">Cálculos Base</h5>
            <div class="d-flex">
              <div class="col-md-6">
                <label class="fw-bolder">INSS 20%</label>
                <div class="d-flex flex-column">
                  <span class="m-1">Faixa de Contribuição = R$7,087,22</span>
                  <span class="m-1">(CALCULO = BASE - INSS 20%)</span>
                  <span class="m-1">R$7,087,22 - 20% = <strong>R$1,417,44</strong></span>
                </div>
              </div>
              <i class="d-flex align-items-center mdi mdi-circle-small font-size-20"></i>
              <div class="col-md-6">
                <label class="fw-bolder">IRRF 27,5%</label>
                <div class="d-flex flex-column">
                  <span class="m-1">Faixa de Contribuição = R$10.908,00</span>
                  <span class="m-1">(R$10.908,00 - R$1,417,44 = R$9.490,56)</span>
                  <span class="m-1">R$9.490,56 - 27,5% (IRRF) = <strong>R$1.740,54</strong></span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- RODAPÉ -->
        <div class="row">
          <div class="d-flex justify-content-between mt-5">
            <div class="col-md-6 align-self-end">
              <div class="barraVerde"></div>
            </div>
            <div class="col-md-6 d-flex flex-column">
              <label class="ms-5 fw-bold">44 4009-3800</label>
              <label class="ms-5 fw-bold">unicampo@unicampo.coop.br</label>
              <label class="ms-5 fw-bold">www.unicampo.coop.br</label>
              <label class="ms-5 fw-bold"
                >Av. Carneiro Leão, 65 Sala 1409 -
                <strong>MARINGÁ PR</strong> CEP: 87013-072</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import folhaProducaoMixin from "@/tools/mixins/folhaProducaoMixin";
import { graficoItensLabel, graficoCategorias } from "./data-apex";
export default {
  mixins: [folhaProducaoMixin],
  layout: "empty",
  data() {
    return {
      graficoItens: false,
      perPage: 100,
      currentPage: 1,
      rows: 0,
      totalProventos: 0,
      totalDescontos: 0,
      camposFolhaProdutor: [
        {
          key: "ds_item",
          label: "Item",
          tdClass: "table-info",
        },
        {
          key: "qt_lcto",
          label: "Dias/Aliq",
          tdClass: "table-info",
        },
        {
          key: "vl_lcto",
          label: "Créditos (+)",
          formatter: (value, item, key) => {
            if (key.tp_natureza === "C") {
              return this.$tools.converteReal(value);
            }
          },
          class: "alinharCelulaDireita",
          thClass: "text-primary",
          tdClass: "text-primary table-info fw-bold",
        },
        {
          key: "tp_natureza",
          label: "Descontos (-)",
          formatter: (value, item, key) => {
            if (value === "D") {
              return this.$tools.converteReal(key.vl_lcto);
            }
          },
          class: "alinharCelulaDireita",
          thClass: "text-danger",
          tdClass: "text-danger table-info fw-bold",
        },
      ],
      tabelaFolhaProdutor: [],
      graficoCreditos: false,
      graficoImpostos: false,
      graficoDebitos: false,
      graficoOutros: false,
      graficoTaxaRetencao: false,
      cabecalho: false,
      // cabecalho: [
      //    {"nm_cooperado":"",
      //     "ano_referencia":"",
      //     "dt_inicio_projeto":"",
      //     "dt_final_projeto":"",
      //     "cd_cooperado":"",
      //     "nm_projeto":"",
      //     "cd_projeto":"",
      //     "nr_matricula":"",
      //     "vl_liquido":"",
      //     "dt_credito":""}],
      valoresFolha: {},
      composicao: [],
      camposComposicao: [
        {
          key: "origem",
          label: "Origem",
          thClass: "col-md-2",
        },
        {
          key: "ds_lancamento",
          label: "Lançamento",
          thClass: "col-md-6",
        },
        {
          key: "dt_lcto",
          label: "Data",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
          thClass: "col-md-2",
        },
        {
          key: "vl_lcto",
          label: "Valor",
          class: "alinharCelulaDireita",
          thClass: "col-md-2",
        },
      ],
      camposDependentes: [
        {
          key: "nm_nome",
          label: "Nome",
        },
        {
          key: "grau_parentesco",
          label: "Grau de parentesco",
        },
        {
          key: "dt_nasc",
          label: "Data de nascimento",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "nr_cpf",
          label: "CPF",
        },
      ],
      tabelaDependentes: [],
    };
  },
  async created() {
    this.$store.commit("SET_MOSTRA_MENU", false);
    await this.filtrarCabecalho();
  },
  methods: {
    async filtrarCabecalho() {
      let cdProjeto = this.$route.params.id.split("-")[0];
      let mesReferencia = this.$route.params.id.split("-")[1];
      let ano_referencia = this.$route.params.id.split("-")[2];
      let responseCabecalho = await this.buscarCabecalho();
      let cabecalhoAux = responseCabecalho.filter((el) => {
        return el.cd_projeto == cdProjeto;
      });
      let cabecalhoFiltrado = "";
      let objFiltragem = mesReferencia + "/" + ano_referencia;
      //let folhas = "";
      cabecalhoFiltrado = cabecalhoAux.find((el) => {
        return el.mes_referencia == objFiltragem;
      });
      this.cabecalho = cabecalhoFiltrado;

      // cabecalhoFiltrado.forEach((el) => {
      //   folhas += el.sq_folha+",";
      // });
      // folhas = folhas.substr(0,folhas.length - 1);
      let item = await this.buscarItem(this.cabecalho.sq_folha);
      this.composicao = await this.buscarComposicao(this.cabecalho.sq_folha);
      this.tabelaDependentes = await this.buscarDependente(
        this.cabecalho.sq_folha
      );
      this.somaValoresFolha(item);
    },
    somaValoresFolha(item) {
      let folhaAux = {};
      folhaAux.vl_proventos = 0;
      folhaAux.vl_descontos = 0;
      folhaAux.vl_impostos = 0;
      folhaAux.vl_outros = 0;
      folhaAux.vl_taxaRetencao = 0;
      folhaAux.vl_bruto = 0;
      folhaAux.vl_descontoTotal = 0;
      item.forEach((el) => {
        switch (parseInt(el.sq_categoria_item_folha)) {
          case 1:
            folhaAux.vl_proventos += parseFloat(el.vl_lcto);
            break;
          case 2:
            folhaAux.vl_impostos += parseFloat(el.vl_lcto);
            break;
          case 3:
            folhaAux.vl_descontos += parseFloat(el.vl_lcto);
            break;
          case 4:
            folhaAux.vl_outros += parseFloat(el.vl_lcto);
            break;
          case 5:
            folhaAux.vl_taxaRetencao += parseFloat(el.vl_lcto);
            break;
        }
      });
      folhaAux.vl_bruto = folhaAux.vl_proventos + folhaAux.vl_outros;
      folhaAux.vl_descontoTotal =
        folhaAux.vl_impostos + folhaAux.vl_descontos + folhaAux.vl_taxaRetencao;
      this.valoresFolha = folhaAux;
      this.graficoItens = graficoItensLabel(item);
      this.graficoCreditos = graficoCategorias(item, 1);
      this.graficoImpostos = graficoCategorias(item, 2);
      this.graficoDebitos = graficoCategorias(item, 3);
      this.graficoOutros = graficoCategorias(item, 4);
      this.graficoTaxaRetencao = graficoCategorias(item, 5);
      item.forEach((el) => {
        el._showDetails = true;
        if (el.tp_natureza === "D") {
          this.totalDescontos += parseFloat(el.vl_lcto);
        } else {
          this.totalProventos += parseFloat(el.vl_lcto);
        }
      });
      this.tabelaFolhaProdutor = item;
    },
    montaDadosComposicao(sqItem) {
      let composicaoFiltrada = this.composicao.filter((el) => {
        return el.sq_item_base == sqItem;
      });
      composicaoFiltrada.forEach((el) => {
        if (el.ds_observacao) {
          el._showDetails = true;
        }
      });
      composicaoFiltrada = composicaoFiltrada.sort((a, b) => {
        return b.vl_lcto - a.vl_lcto;
      });
      return composicaoFiltrada;
    },
  },
};
</script>
<style scoped>
.barraVerde {
  width: 100%;
  height: 15px;
  background-color: #00923f;
}
</style>
